import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  LOGIN_ROUTE_NAME,
  TRANSLATION_GROUP_LOGIN,
} from './constants';
import { getTranslationKeys } from './translations';

export class LoginModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAnonymousRoute({
      name: LOGIN_ROUTE_NAME,
      path: '/sign_in',
      component: () => import('./pages/LoginPage/LoginPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_LOGIN, getTranslationKeys);
  }
}
